/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unused-prop-types */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import './Icon.scss';

export default class Icon extends Component {
  static propTypes = {

    /** Theme dark */
    dark: PropTypes.bool,

    /** Style primary */
    primary: PropTypes.bool,

    /** Style secondary */
    secondary: PropTypes.bool,

    /** Style tertiary */
    tertiary: PropTypes.bool,

    /** Style xLarge */
    xLarge: PropTypes.bool,

    /** Size medium */
    medium: PropTypes.bool,

    /** Icon name */
    name: PropTypes.string,

    /** Click event */
    onClick: PropTypes.func,

    /** Mouse over event */
    onMouseOver: PropTypes.func,

    className: PropTypes.string,
  };

  static defaultProps = {
    dark: false,
    primary: false,
    secondary: false,
    tertiary: false,
    medium: false,
    onClick: null,
    onMouseOver: null,
    name: '',
    xLarge: false,
    className: '',
  };

  state = {
    iconClassNames: null,
  };

  static getIconNameFromProps(props) {
    const iconName = Object.entries(props).find(x => x[1] === true);
    return iconName && iconName[0];
  }

  static getDerivedStateFromProps(props) {
    const {
      medium,
      name,
      dark,
      primary,
      secondary,
      tertiary,
      xLarge,
    } = props;

    const iconName = name || Icon.getIconNameFromProps(props);

    return {
      iconClassNames: classNames(
        [props.className], {
          icon: true,
          [`ra-icon-${iconName}`]: true,
          medium,
          dark,
          primary,
          secondary,
          tertiary,
          'x-large': xLarge,
        }
      ),
    };
  }

  render() {
    const { iconClassNames } = this.state;
    const { onClick, onMouseOver } = this.props;

    return (
      iconClassNames
      && (
        <i
          onFocus={onMouseOver}
          onMouseOver={onMouseOver}
          className={iconClassNames}
          onClick={onClick}
        />
      )
    );
  }
}
